import gql from "graphql-tag";
import {VeriflytAccountFragment} from "../../../Queries/Veriflyt";
import {useQuery} from "react-apollo";
import {VeriflytAccountFragmentFragment} from "../../../__generated__/graphql/types";

export const QueryAccountLookup = gql`
    query VeriflytIDLookup($veriflytID: ID!) {
        GetVeriflytAccount(veriflytID: $veriflytID) {
            ...VeriflytAccountFragment
        }
    }
    ${VeriflytAccountFragment}
`

export function useAccountLookup(veriflytID: string, onCompleted: () => void = () => {}) {
    const { data, loading, error } = useQuery(QueryAccountLookup, {
        variables: { veriflytID },
        skip: !veriflytID,
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all',
        onCompleted: onCompleted
    });

    return {
        account: data?.GetVeriflytAccount as VeriflytAccountFragmentFragment,
        loading: loading,
        error: error
    }
}